import { api } from "@/lib/api";

export type Invitation = {
  id: string;
  organizationId: string;
  organizationName: string;
  email: string;
  role: "member" | "admin" | "owner" | null;
  status: string;
  inviterId: string;
  inviterName: string;
  expiresAt: Date;
};

export function useOrgInvitations() {
  const { data, isFetching, refetch } = api.useQuery("get", "/invitations/user");

  // Convert ISO strings to Date objects
  const invitations = data?.map((inv) => ({
    ...inv,
    expiresAt: new Date(inv.expiresAt),
  }));

  return {
    invitations: invitations ?? [],
    isPending: isFetching,
    refetch,
  };
}
